import {save} from '../../app-components/action/SaveAction';
import {cancelButton} from '../../app-components/action/CloseAction';
import ccmForm from './ccmForm';
let header = {
  title: 'Add CCM Checklist',
  actions: [cancelButton(), save()],
};

export default ccmForm({header});
